import { useMemo } from "react";
import { useBeforeUnload } from "react-use";
import { Prompt } from "react-router";

export interface CustomPromptProps {
  shouldBlockNavigation: boolean;
  content?: string;
}
export const CustomPrompt = ({
  shouldBlockNavigation,
  content
}: CustomPromptProps): JSX.Element => {
  const message = useMemo(() => {
    let text =
      "You have unsaved changes, Are you sure you want to navigate away?";
    if (content) {
      text = content;
    }
    return text;
  }, [content]);

  /** Prevent without react-router reload either */
  useBeforeUnload(shouldBlockNavigation, message);

  return <Prompt when={shouldBlockNavigation} message={message} />;
};
